export const PREVIEW_PARAM = "preview";
export const HBS_DOMAIN_PARAM = "domain";
export const CONTENTFUL_ENV_PARAM = "environment";

export const ES_QUERY_ENDPOINT = "https://www.hbs.edu/api/contentful/search";
export const NAVIGATION_PAGE_TYPES = [
  "landingPage",
  "detailPage",
  "archivePage",
]; // only these page types appear in navigation (breadcrumbs, side-nav)
export const CONTENTFUL_PAGE_TYPES = [
  ...NAVIGATION_PAGE_TYPES,
  "articlePage",
  "coursePage",
  "programPage",
  "profilePage",
  "participantStory",
  "knowledgeBaseArticlePage",
  "databasePage",
  "datasetPage",
  "podcastEpisodePage",
  "clubPage",
  "eventDetailPage",
  "issueLandingPage",
];
export const productionDomains = [
  "www.hbs.edu",
  "my.hbs.edu",
  "www.library.hbs.edu",
  "www.exed.hbs.edu",
  "www.alumni.hbs.edu",
  "online.hbs.edu",
];

export const GOOGLE_TAG_IDS = {
  DEFAULT: "GTM-N2NWNWX",
  ONLINE: "GTM-MW34RML",
  EXED: "GTM-TLS4CQL",
  // Server-side GTM pilot, enabled with ?sgtm-pilot=true
  EXED_SGTM: "7acaqzcz=Ag5ULT8%2BWj8nOV0pOj9RHVZYR1tNFxlWAwgaRA4XAg%3D%3D",
  MY: "GTM-WNLL79Z",
};

const GTM_SOURCE = "https://www.googletagmanager.com/gtm.js?id=";

// Script URL prefix for each tag; the tag ID is appended to it
export const GOOGLE_TAG_SOURCE: Record<keyof typeof GOOGLE_TAG_IDS, string> = {
  DEFAULT: GTM_SOURCE,
  ONLINE: GTM_SOURCE,
  EXED: GTM_SOURCE,
  EXED_SGTM: "https://tr.hbs.edu/467r0kwskjijk.js?",
  MY: GTM_SOURCE,
};

export function getGoogleTagSource(gtagId: string) {
  const key = (
    Object.keys(GOOGLE_TAG_IDS) as Array<keyof typeof GOOGLE_TAG_IDS>
  ).find((k) => GOOGLE_TAG_IDS[k] === gtagId);
  return GOOGLE_TAG_SOURCE[key ?? "DEFAULT"];
}

export const DEFAULT_USER_AGENT = "hbs-design-system";

export const CONTENTFUL_GROUP = {
  FIRST_SECOND_YEAR_MBA: "G_48237", // First and Second Year of MBA Program
  PREMATRICS: "G_48566", //Prematrics for the MBA Program
};
